let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("16B8C")]).then(() => parcelRequire('lJ0K6'));